"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _richTextReactRenderer = require("@contentful/rich-text-react-renderer");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _configOptions = require("./configOptions");
var _RichTextPropTypes = require("./RichTextPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultProps = {
  linkColour: 'alternative',
  colour: 'default',
  paragraphSize: 'medium',
  inverse: false
};
var RichText = props => {
  var _props$richText$conte;
  if (!props.richText || !((_props$richText$conte = props.richText.content) !== null && _props$richText$conte !== void 0 && _props$richText$conte.length)) return null;
  var options = (0, _configOptions.configOptions)(_objectSpread(_objectSpread({}, defaultProps), props));
  // colour prop supports secondary and ternary but ternary doesn't exists and secondary is an slightly lighter color than primary. See https://github.com/telus/universal-design-system/issues/2550
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "rich-text-testid",
    style: {
      position: 'relative'
    }
  }, (0, _richTextReactRenderer.documentToReactComponents)(props.richText, options));
};
RichText.propTypes = {
  paragraphSize: _propTypes.default.oneOf(_RichTextPropTypes.variantSizes),
  colour: _propTypes.default.oneOf(_RichTextPropTypes.variantColors),
  align: _propTypes.default.oneOf(_RichTextPropTypes.alignOptions),
  richText: _RichTextPropTypes.documentNodeProp,
  linkColour: _propTypes.default.oneOf(_RichTextPropTypes.linkColourOptions),
  inverse: _propTypes.default.bool,
  iconName: _propTypes.default.string,
  iconColor: _propTypes.default.oneOf(_RichTextPropTypes.iconColorOptions),
  iconSize: _propTypes.default.oneOf(_RichTextPropTypes.iconSizeOptions),
  linkTarget: _propTypes.default.oneOf(_RichTextPropTypes.linkTargetOptions)
};
var _default = exports.default = RichText;